// Static SVG backdrop for the football minigame.
// pointer-events: none — all click handling belongs to the game layer above.
export default function FootballField({ losY = 480, endZoneY = 80 }) {
  const W = 600, H = 600;

  // Yard lines drawn every 49px inside the playing field
  const yardLineYs = [];
  for (let y = endZoneY + 49; y < 565; y += 49) yardLineYs.push(y);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      {/* Grass */}
      <div className="absolute inset-0" style={{ background: "#15803d" }} />
      {/* End zone — darker green */}
      <div className="absolute left-0 right-0 top-0" style={{ height: endZoneY, background: "#166534" }} />

      <svg
        className="absolute inset-0"
        width={W}
        height={H}
        viewBox={`0 0 ${W} ${H}`}
        style={{ pointerEvents: "none" }}
      >
        {/* End zone bottom border */}
        <line x1="0" y1={endZoneY} x2={W} y2={endZoneY} stroke="white" strokeWidth="3" />

        {/* END ZONE label */}
        <text
          x={W / 2} y={endZoneY / 2 + 5}
          textAnchor="middle"
          fill="rgba(255,255,255,0.45)"
          fontSize="13"
          fontWeight="bold"
          letterSpacing="5"
          fontFamily="monospace"
        >
          END ZONE
        </text>

        {/* Yard lines */}
        {yardLineYs.map(y => (
          <g key={y}>
            <line x1="0" y1={y} x2={W} y2={y} stroke="white" strokeWidth="1" opacity="0.18" />
            {/* Hash marks at ~1/3 and ~2/3 field width */}
            <line x1="205" y1={y - 5} x2="205" y2={y + 5} stroke="white" strokeWidth="1.5" opacity="0.3" />
            <line x1="395" y1={y - 5} x2="395" y2={y + 5} stroke="white" strokeWidth="1.5" opacity="0.3" />
          </g>
        ))}

        {/* Sideline markers */}
        <line x1="8"     y1={endZoneY} x2="8"     y2="570" stroke="white" strokeWidth="2" opacity="0.35" />
        <line x1={W - 8} y1={endZoneY} x2={W - 8} y2="570" stroke="white" strokeWidth="2" opacity="0.35" />

        {/* Bottom boundary (offense back line) */}
        <line x1="0" y1="570" x2={W} y2="570" stroke="white" strokeWidth="2" opacity="0.3" />

        {/* LOS marker — amber dashed */}
        <line
          x1="0" y1={losY} x2={W} y2={losY}
          stroke="#fbbf24" strokeWidth="2" strokeDasharray="10,5" opacity="0.55"
        />
        <text x="10" y={losY - 5} fill="#fbbf24" fontSize="10" opacity="0.6" fontWeight="bold" fontFamily="monospace">
          LOS
        </text>
      </svg>
    </div>
  );
}
